// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const REVIEW_VERIFIED = "Overen\u00e1 recenzia";
export const WIKI_EXP_DRAFT_VERIFIED_BY_PHONE_CALL = "Overen\u00e9 adminom";
export const WIKI_EXP_GUEST_LABEL = "hos\u0165";
